<template>
    <div class="upsell-summary-items">
        <ul class="upsell-summary-items-listing">
            <li
                v-for="(item, index) in localData"
                :key="index"
                class="upsell-summary-items-listing__item typographies-paragraph-medium-regular"
            >
                <div class="upsell-summary-items-listing__item-label">
                    <span>
                        <span v-if="isPlan(item)">{{ $l10n.__('Plan ') }}</span>
                        {{ item.label }}
                        <span v-if="hasQuantity(item)"> x{{ item.quantity }}</span>
                    </span>

                    <ChargebeeUpsellTag
                        v-if="hasTag(item)"
                        :quantity="item.updatedQuantity"
                        :label="tagLabel(item)"
                        :showQuantity="!isOption(item)"
                    />
                </div>
                <div v-if="!isPlan(item)" class="upsell-summary-items-listing__item-price">
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $filters.numberFormatCurrency(humanizeCentsPrice(item.amount)) }}
                    </span>
                    <span v-if="item.recurrence" class="typographies-paragraph-small-regular">
                        /{{ recurrence(item.recurrence) }}
                    </span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import ChargebeeUpsellTag from 'vcomponents/pages/account/upsell/ChargebeeUpsellTag.vue';
import ChargebeeUpsellMixin from 'mixins/chargebee/ChargebeeUpsellMixins';
import { createNamespacedHelpers } from 'vuex';
import { isOption, isSubOption } from 'js/vue/helpers/chargebee/chargebeeUpsellHelpers.js';

const chargebeeUpsellStore = createNamespacedHelpers('chargebeeUpsellStore');

export default {
    components: { ChargebeeUpsellTag },
    mixins: [ChargebeeUpsellMixin],
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    computed: {
        ...chargebeeUpsellStore.mapGetters(['getSubscriptionItems']),
        localData() {
            return this.data.filter((addon) => {
                if (!addon.newItem) {
                    return (
                        !(addon.quantity === 0 && addon.updatedQuantity === 0) || addon.quantity > 0
                    );
                }
                return addon.quantity > 0;
            });
        },
    },
    methods: {
        isOption,
        isPlan(item) {
            return item.item_type === 'plan';
        },
        hasQuantity(item) {
            return !isOption(item) && !this.isPlan(item);
        },
        isFullAddon(item) {
            return ['full', 'removed'].includes(item.status);
        },
        hasTag(item) {
            return !this.isPlan(item) && (item.updatedQuantity !== 0 || !this.isFullAddon(item));
        },
        tagLabel(item) {
            let label;
            const updatedQuantity =
                item.updatedQuantity < 0 ? item.updatedQuantity * -1 : item.updatedQuantity;

            if (this.isFullAddon(item)) {
                if (isSubOption(item)) {
                    label = this.$l10n.n__('option', 'options', updatedQuantity, updatedQuantity);
                } else {
                    label = isOption(item)
                        ? this.$l10n.__('module')
                        : this.$l10n.n__('licence', 'licences', updatedQuantity, updatedQuantity);
                }
            } else {
                const quantity = updatedQuantity > 0 ? updatedQuantity : item.quantity;

                switch (item.status) {
                    case 'free':
                        label = this.$l10n.n__('offerte', 'offertes', quantity, quantity);
                        break;
                    case 'discount':
                        label = this.$l10n.n__('remisée', 'remisées', quantity, quantity);
                        break;
                    case 'modified':
                        label = this.$l10n.__('modification');
                        break;
                }
            }

            return label;
        },
    },
};
</script>
<style lang="scss" scoped>
.upsell-summary-items {
    display: flex;
    flex-direction: column;

    &-heading {
        display: flex;
        justify-content: space-between;
        margin: 0;
    }

    &-listing {
        margin: 0;

        &__item {
            display: flex;
            justify-content: space-between;

            &-price {
                white-space: nowrap;
            }

            &-label {
                display: flex;
                align-items: center;
                margin-bottom: var(--spacing-0);
            }

            &-price {
                white-space: nowrap;
            }
        }
    }
}
</style>
